// Популярность - Прибыльность
export default [
  {
    title: 'Всё пропало, шеф!',
    text: 'Денег нет, аудитория прошла мимо. Что поделать, это суровый мир, в котором выживают не все. Не переживай, просто займись другим бизнесом.',
    conditions: ['popularity <= 0', 'profitability <= 0'],
  },
  {
    title: 'Ау, где все?',
    text: 'У тебя есть какие-то деньги, но толку? Пользователи не хотят читать твой сайт! Может, он никому не нужен?',
    conditions: ['popularity <= 0', 'profitability > 0'],
  },
  {
    title: 'Денег нет, но вы держитесь.',
    text: 'Деньги кончились. Задерживать зарплату больше некому: редакция разбежалась. Остались только преданные читатели.',
    conditions: ['popularity > 0', 'profitability <= 0'],
  },
  {
    title: 'Бог трафика.',
    text: 'Неплохой результат, ты знаешь, что нужно людям. Твой сайт читают, о нём говорят, на него ссылаются, от него не могут оторваться. Осталось только научиться делать деньги.',
    conditions: ['popularity > 4', 'profitability < 5'],
  },
  {
    title: 'Большой босс.',
    text: 'Заработать на медиа трудно, но тебе это удалось. Всемирной славы ты не добился, конечно, зато у тебя есть деньги.',
    conditions: ['popularity < 5', 'profitability > 4'],
  },
  {
    title: 'Лайфхакер.',
    text: 'Невероятно, но ты это сделал. У тебя есть деньги, и тебя любит публика. Срочно пиши книгу «Как добиться успеха в медиабизнесе», тебе уже можно.',
    conditions: ['popularity > 4', 'profitability > 4'],
  },
]



// WEBPACK FOOTER //
// ./src/data/outcomes.js